export const SET_VISIBLE_SHUTDOWN_FILTER = 'SET_VISIBLE_SHUTDOWN_FILTER';
export const SET_CHANHGED_SHUTDOWN_FILTER = 'SET_CHANHGED_SHUTDOWN_FILTER';
export const SET_CHOSEN_SHUTDOWN_FILTER = 'SET_CHOSEN_SHUTDOWN_FILTER';
export const SET_DATE_RANGE_FIELD_SHUTDOWN_FILTER =
  'SET_DATE_RANGE_FIELD_SHUTDOWN_FILTER';
export const SET_DATE_RANGE_SHUTDOWN_FILTER = 'SET_DATE_RANGE_SHUTDOWN_FILTER';
export const SET_COMPANY_ID_SHUTDOWN_FILTER = 'SET_COMPANY_ID_SHUTDOWN_FILTER';
export const SET_TYPE_ID_SHUTDOWN_FILTER = 'SET_TYPE_ID_SHUTDOWN_FILTER';
export const SET_REASON_ID_SHUTDOWN_FILTER = 'SET_REASON_ID_SHUTDOWN_FILTER';
export const SET_STREET_ID_SHUTDOWN_FILTER = 'SET_STREET_ID_SHUTDOWN_FILTER';
export const SET_HOUSE_ID_SHUTDOWN_FILTER = 'SET_HOUSE_ID_SHUTDOWN_FILTER';
export const SET_ADDRESS_IDS_SHUTDOWN_FILTER =
  'SET_ADDRESS_IDS_SHUTDOWN_FILTER';
export const SET_ONLY_ACTIVE_SHUTDOWN_FILTER =
  'SET_ONLY_ACTIVE_SHUTDOWN_FILTER';
export const SET_INITIATOR_ID_SHUTDOWN_FILTER =
  'SET_INITIATOR_ID_SHUTDOWN_FILTER';
export const SET_RESPOSIBLE_ID_SHUTDOWN_FILTER =
  'SET_RESPOSIBLE_ID_SHUTDOWN_FILTER';
export const SET_SHUTDOWN_FILTER_VALUES = 'SET_SHUTDOWN_FILTER_VALUES';
export const RESET_SHUTDOWN_FILTER_VALUES = 'RESET_SHUTDOWN_FILTER_VALUES';
export const SET_CREATE_WORKER_ID_SHUTDOWN_FILTER =
  'SET_CREATE_WORKER_ID_SHUTDOWN_FILTER';
export const SET_CITY_ID_SHUTDOWN_FILTER = 'SET_CITY_ID_SHUTDOWN_FILTER';
export const SET_IS_PLAYING_SHUTDOWN_FILTER = 'SET_IS_PLAYING_SHUTDOWN_FILTER';
export const SET_FOR_EDDS_SHUTDOWN_FILTER = 'SET_FOR_EDDS_SHUTDOWN_FILTER';
export const SET_SEARCH_VALUE_SHUTDOWN_FILTER =
  'SET_SEARCH_VALUE_SHUTDOWN_FILTER';
export const SET_VALUE_NEW_SHUTDOWN = 'SET_VALUE_NEW_SHUTDOWN';
